package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository

class LeaveTableUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(
        tableId: String,
        userId: String
    ): Result<Unit> = gameTableRepository.leaveTable(tableId, userId)
}
